<div class="innerpage-fullwithbanner" *ngIf="showHeader">
  <h2 class="bighead">{{prospectDetails.Name!=null?prospectDetails.Name:''}}</h2>
  <ul class="bread-crumbs">
    <li><a (click)="_validationService.redirect('/')">Home<span>|</span></a></li>
    <li>
      <a (click)="onBreadCrumbClick();">{{prevPage!='Prospects'?prevPage:'External Users'}}<span>|</span></a>
    </li>
    <li>Prospects Profile</li>
  </ul>
</div>
<div class="section-margin">
  <div class="container container-lg">
    <div class="margin0">
      <div>
        <div *ngIf="showHeader">
          <div class="border-div">
            <div class="d-flex chart-box-header align-item-center">
              <h2 class="mainhead mr-auto mainhead2"><span class="text">Profile Details</span></h2>
              <div class="like-view-div  margin-right-20">
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label class="form-label">Name</label>
                  <h6 class="displayvalue margin-top-15">{{prospectDetails.Name!=null?prospectDetails.Name:'-'}}</h6>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label class="form-label">Organization</label>
                  <h6 class="displayvalue margin-top-15">{{prospectDetails.CompanyName!=null?prospectDetails.CompanyName:'-'}}</h6>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                <div class="form-group" *ngIf="!enableEmailEditField">
                  <label class="form-label">
                    Email ID
                    <a class="blueone quick-edit" *ngIf="prospectDetails!=null&&(prospectDetails.Email==null||prospectDetails.Email=='')" tooltip="Edit" href="javascript:void(0);" (click)="enableEmailEdit()"><i class="icofont icofont-ui-edit" aria-hidden="true"></i></a>
                  </label>
                  <h6 class="displayvalue margin-top-15">{{prospectDetails.Email!=null&&prospectDetails.Email!=''?prospectDetails.Email:'-'}}</h6>
                </div>
                <form [formGroup]="emailForm" autocomplete="off" #formDir="ngForm" name="form" *ngIf="enableEmailEditField">
                  <div class="form-group">
                    <label class="form-label">Email<span class="red">*</span></label>
                    <input class="form-control" id="input_prospect_email" style="height:26px !important;" formControlName="emailinput" (change)="validateemail()" [(ngModel)]="userEmailAddress" required type="text" maxlength="100" autocomplete="off">
                    <p class="redtext" *ngIf="(emailValid) && emailinput.invalid && emailinput.touched">Email is required</p>
                    <p class="redtext" *ngIf="(!emailValid) && emailvalidation ==''">Email is required</p>
                    <p class="redtext" *ngIf="(emailvalidation!='' && userEmailAddress!='')">{{emailvalidation}}</p>
                  </div>
                </form>
              </div>

              <div class="col-lg-3 col-md-2 col-sm-6 col-xs-12" id="prospect-phn-number">
                <div class="form-group">
                  <label class="form-label">Phone</label>
                  <h6 class="displayvalue margin-top-15">{{prospectDetails.PhoneNumber!=null&&prospectDetails.PhoneNumber!=''? FormatPhone(prospectDetails.PhoneNumber):'-'}}</h6>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label class="form-label">Contact Type</label>
                  <h6 class="displayvalue margin-top-15">{{prospectDetails.Role!=null?prospectDetails.Role:'-'}}</h6>
                </div>
              </div>
            </div>
            <div class="text-right" *ngIf="enableEmailEditField">
              <button type="button" class="btn btn-default btn-lg" (click)="closeEmailEdit();">Cancel</button>
              <button class="btn btn-success  btn-lg" (click)="saveEmail();">Save</button>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="container container-lg min-heightcontainer be-buy-page-wrap margin0">
          <div class="border-div margin0">
            <div class="tabstyle2 offerdetailstab-padding pos-relative">
              <ul class="switchingproperty margin-bottom-15 offerlistingtab">
                <li [class.active]="activeMenu === menu.LiveListings">
                  <a (click)="onTabClick(menu.LiveListings)">
                    Live Listings
                  </a>
                </li>
                <li [class.active]="activeMenu === menu.OffMarket">
                  <a (click)="onTabClick(menu.OffMarket)">
                    Off-Market
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <div class="margin-top-30">
                <div class="d-flex filter-header-rt floatinghead clearfix">
                  <div class="leftside d-flex" *ngIf="selectedLiveListings!=null && selectedLiveListings.length>0">
                    <label class="whitespacenowrap margin-right-5">Selected Properties: </label>
                    <div class="margin-left-5 d-block">
                      <span *ngFor="let selectedData of selectedLiveListings; let j = index">
                        <span class="Off-Market margin-right-5 margin-bottom-5" *ngIf="j<5||IsSelectedPropertyOpened">
                          {{ selectedData.PropertyName}}
                          <a href="javascript:void(0);" (click)="onSelectedPropertyRemove(selectedData.Id)">
                            <i class="icofont icofont-close"></i>
                          </a>
                        </span>
                      </span>
                      <span *ngIf="selectedLiveListings.length>selectedCheckboxDataLimit&&!IsSelectedPropertyOpened" class="Off-Market margin-right-5 margin-bottom-5">
                        <a href="javascript:void(0);" (click)="onViewAllProperties()">
                          {{'+' + (selectedLiveListings.length-selectedCheckboxDataLimit) }} More
                        </a>
                      </span>
                    </div>
                  </div>
                  <div class="rightside d-flex ml-auto" *ngIf="permissionService.hasPermission(Modules.Prospects,Actions.BulkUpdate)">
                    <div class="search-sec " style="padding-right: 10px">
                      <input class="form-control" type="text" (keyup)="onSearch($event.target.value)" placeholder="Search" id="import-search">
                      <i aria-hidden="true" class="fa fa-search icon"></i>
                    </div>
                    <div style="padding-left: 5px">
                      <button type="button" class="btn btn-border btn-lg"
                              aria-controls="dropdown-basic" tooltip="Bulk Update" triggers="mouseenter:mouseleave"
                              placement="left" (click)="bulkUpdateProperties(BulkUpdate,'panlestyle',0)">
                        Bulk Update
                      </button>
                    </div>
                  </div>
                </div>
                <div class="cf"></div>
                <div class="table-responsive table-fixed table-v-scroll margin0" style="width: 100%">
                  <table class="table basictable row-border hover" datatable [dtOptions]="dtoptions">
                    <thead>
                      <tr>
                        <th data-orderable="false" style="width:5px">
                          <label class="custom-checkbox withoutlabel">
                            <input type="checkbox" [(ngModel)]="selectAll" (change)="onSelectAll($event);" class="ng-pristine ng-valid ng-touched"><i></i>Select
                          </label>
                        </th>
                        <th style="width:2px">
                        </th>
                        <th class="remove hidden-xs" style="cursor:auto" data-orderable="false"></th>
                        <th>Property Name</th>
                        <th>Status</th>
                        <th>OM</th>
                        <th>NDA</th>
                        <th>Notes</th>
                        <th data-orderable="false">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let property of propertyList;let i = index">
                        <td>
                          <label class="custom-checkbox withoutlabel">
                            <input type="checkbox" [(ngModel)]="property.IsSelected" (change)="onCheckboxChange($event,property.Id);" class="ng-pristine ng-valid ng-touched"><i></i>
                          </label>
                        </td>
                        <td></td>
                        <td>
                          <a>
                            <div class="property-image portfolio-img" *ngIf="property?.IsPortfolio">
                              <ng-container *ngIf="property.PortfolioFilePath && property.PortfolioFilePath.length == 0">
                                <img src="assets/img/default-property_1.png" />
                              </ng-container>
                              <ng-container *ngIf="property.IsPortfolio && property.PortfolioFilePath && property.PortfolioFilePath.length > 0">
                                <ng-container *ngFor="let image of property.PortfolioFilePath;  let im=index">
                                  <img *ngIf="im < 3" [src]="image" placement="top" onerror="this.onerror=null;this.src='assets/img/default-property_1.png'" />
                                </ng-container>
                              </ng-container>
                            </div>
                            <div class="property-image" *ngIf="!property.IsPortfolio">
                              <img [src]="property.FilePath" placement="top" onerror="this.onerror=null;this.src='assets/img/default-property_1.png'" />
                            </div>
                          </a>
                        </td>
                        <td class="sticky-left">
                          <div style="display:table">
                            <p><a target="_blank" href="#" routerLink="/viewproperty/{{property.Guid}}">{{property.PropertyName}}</a></p>
                            <p *ngIf="property.City">{{ property.City +', '+ property.State}}</p>
                          </div>
                        </td>
                        <td>
                          <p>{{property.Status}}</p>
                        </td>
                        <td>
                          <label class="custom-checkbox withoutlabel" *ngIf="property.LatestProspectId>0">
                            <input disabled type="checkbox" [(ngModel)]="property.OMDownloads" class="ng-pristine ng-valid ng-touched"><i></i>
                          </label>
                        </td>
                        <td>
                          <label class="custom-checkbox withoutlabel" *ngIf="property.LatestProspectId>0">
                            <input disabled type="checkbox" [(ngModel)]="property.NDAExecuted" class="ng-pristine ng-valid ng-touched"><i></i>
                          </label>
                        </td>
                        <td>
                          <p>{{property.Notes}}</p>
                        </td>
                        <td>
                          <p *ngIf="permissionService.hasPermission(Modules.Prospects,Actions.Edit)">
                            <button id="button-basic" type="button" class="blueone"
                                    placement="top" tooltip="Action">
                              <i class="fa fa-cog" aria-hidden="true" (click)="getProspectDetails(EditProspects,'panlestyle',property.LatestProspectId,property.Id,property.IsPortfolio)"></i>
                            </button>
                          </p>
                        </td>
                      </tr>

                    </tbody>
                    <tfoot>
                      <tr *ngIf="propertyList?.length == 0 && !IsDataProcessing">
                        <td colspan="8" class="odd no-data-available">
                          <div class="nodata">
                            <i class="fa fa-exclamation-triangle icon"></i>
                            <p>No Data Available</p>
                          </div>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #BulkUpdate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{(IsEditMode ? "Edit Details" : "Bulk Update")}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="prospectForm" autocomplete="off" #formDir="ngForm" class="property-form" name="form">
      <!--Active class required when click-->
      <div class="border-div bulk-upload-collapse" id="BulkUpdateDiv" (click)="showFullProperties()">
        <p class="d-flex align-items-center margin0">
          Selected Properties <span class="countstyle margin-left-5">{{selectedLiveListings.length}}</span>
          <span *ngIf="selectedLiveListings.length >0" class="btn-collapse ml-auto" [class.span-open]="IspropertyOpened">
            <i class="fa fa-angle-down" aria-hidden="true" *ngIf="!IspropertyOpened"></i>
            <i class="fa fa-angle-up" aria-hidden="true" *ngIf="IspropertyOpened"></i>
          </span>
        </p>
        <div class="table-fixed table-v2 margin-top-20" *ngIf="IspropertyOpened">
          <div class="table-responsive table-gray-hd margin0">
            <table class="table basictable">
              <thead>
                <tr>
                  <th class="remove hidden-xs" style="cursor:auto" data-orderable="false"></th>
                  <th>Property Name</th>
                  <th>Remove</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let properties of selectedLiveListings;let i = index">
                  <td>
                    <a>
                      <div class="property-image portfolio-img" *ngIf="properties.IsPortfolio">
                        <ng-container *ngIf="properties.PortfolioFilePath && properties.PortfolioFilePath.length == 0">
                          <img src="assets/img/default-property_1.png" />
                        </ng-container>
                        <ng-container *ngIf="properties.IsPortfolio && properties.PortfolioFilePath && properties.PortfolioFilePath.length > 0">
                          <ng-container *ngFor="let image of properties.PortfolioFilePath;  let im=index">
                            <img *ngIf="im < 3" [src]="image" placement="top" onerror="this.onerror=null;this.src='assets/img/default-property_1.png'" />
                          </ng-container>
                        </ng-container>
                      </div>
                      <div class="property-image" *ngIf="!properties.IsPortfolio">
                        <img [src]="properties.FilePath" placement="top" onerror="this.onerror=null;this.src='assets/img/default-property_1.png'" />
                      </div>
                    </a>
                  </td>
                  <td>
                    <p><a target="_blank" href="#" routerLink="/viewproperty/{{properties.Guid}}">{{properties.PropertyName}}</a></p>
                    <p *ngIf="properties.City">{{ properties.City +', '+ properties.State}}</p>
                  </td>
                  <td>
                    <p>
                      <a class="remove" tooltip="Remove" href="javascript:void(0);" (click)="removeProperty(properties.Id)"><i class="icofont icofont-close" aria-hidden="true"></i></a>
                    </p>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr *ngIf="selectedLiveListings?.length == 0 ">
                  <td colspan="3" class="odd no-data-available">
                    <div class="nodata">
                      <i class="fa fa-exclamation-triangle icon"></i>
                      <p>No Property Available</p>
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label class="form-label">
          Status<span class="red">*</span>
        </label>
        <label class="select">
          <select class="form-control" formControlName="lstStatus"
                  [(ngModel)]="prospectModel.ProspectStatusId" [required] (change)="addFeedBack()">
            <option [ngValue]="null" disabled selected hidden>Select</option>
            <option [ngValue]="item.id" *ngFor="let item of statusList">{{item.description}}</option>
          </select>
          <i></i>
        </label>
      </div>
      <div class="form-group" [hidden]="prospectModel.ProspectStatusId != 5007">
        <label class="form-label">
          Feedback
        </label>
        <div class="select-dropdown multiselectdesign margin-right-15  multi-check-dropdown">
          <mat-form-field>
            <mat-select placeholder="Select" (click)="addClassToOverlayContainer();" [(ngModel)]="prospectModel.Feedback" multiple [ngModelOptions]="{standalone: true}">
              @if (prospectModel.Feedback!=null&&prospectModel.Feedback.length > 1) {
              <mat-select-trigger (click)="$event.stopPropagation()">
                <span>{{ prospectModel?.Feedback.length }} items selected</span>
              </mat-select-trigger>
              }
              @for (feedack of feedackList; track feedack) {
              <mat-option [value]="feedack.id" class="multi-dropdown-item">{{feedack.name}}</mat-option>
              }
              <mat-option class="matoptionnodata" *ngIf="feedackList?.length === 0" disabled>
                Nothing found...
              </mat-option>
            </mat-select>
          </mat-form-field>
          <!--<angular2-multiselect formControlName="lstFeedback" [data]="feedackList" [(ngModel)]="prospectModel.Feedback" [settings]="defaultSettings"></angular2-multiselect>-->
          <i></i>
        </div>
      </div>
      <div class="form-group checkbox-margin-top margin-bottom-20">
        <label class="custom-checkbox margin-right-20 margin-bottom-0" for="checkboxOMDownloads">
          <input type="checkbox" formControlName="BulkchkOMDownloads" [(ngModel)]="prospectModel.OMDownloads" id="checkboxOMDownloads" />
          OM Downloads
          <i></i>
        </label>
        <label class="custom-checkbox margin-bottom-0 margin-right-20" for="checkboxNDAExecuted">
          <input type="checkbox" formControlName="BulkchkNDAExecuted" [(ngModel)]="prospectModel.NDAExecuted" id="checkboxNDAExecuted" />
          NDA Executed
          <i></i>
        </label>
      </div>
      <div class="form-group">
        <label class="form-label">
          Notes
        </label>
        <input placeholder="Notes" formControlName="txtNotes" type="text" maxlength="500" [(ngModel)]="prospectModel.Notes" class="form-control">
      </div>

      <div class="form-group">
        <div class="text-right">
          <button type="button" (click)="onClose()" class="btn btn-default btn-lg">Cancel</button>
          <button type="button" (click)="bulkUpdateProspects()" class="btn btn-success btn-lg">Save</button>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #EditProspects>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Edit Details</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="prospectEditForm" autocomplete="off" #formDir="ngForm" class="property-form" name="form">
      <div class="property-tags margin-bottom-15">
        <p class="pro-name margin0">
          {{prospectEditProperty}}
        </p>
        <p class="pro-loc margin0">
          {{prospectEditLocation}}
        </p>
      </div>
      <div class="form-group checkbox-margin-top margin-bottom-20">
        <label class="custom-checkbox margin-right-20 margin-bottom-0" for="checkboxOMDownloads">
          <input [attr.disabled]="prospectEditModel.IsOmOrNda ? true: null" type="checkbox" formControlName="chkOMDownloads" [(ngModel)]="prospectEditModel.OMDownloads" id="checkboxOMDownloads" />
          OM Downloads
          <i></i>
        </label>
        <label class="custom-checkbox margin-bottom-0 margin-right-20" for="checkboxNDAExecuted">
          <input [attr.disabled]="prospectEditModel.IsOmOrNda ? true: null" type="checkbox" formControlName="chkNDAExecuted" [(ngModel)]="prospectEditModel.NDAExecuted" id="checkboxNDAExecuted" />
          NDA Executed
          <i></i>
        </label>
      </div>
      <div class="form-group">
        <label class="form-label">
          Status<span class="red">*</span>
        </label>
        <label class="select">
          <select class="form-control" formControlName="editlstStatus"
                  [(ngModel)]="prospectEditModel.Status" [required] (change)="addFeedBack()">
            <option [ngValue]="null" disabled selected hidden>Select</option>
            <option [ngValue]="item.id" *ngFor="let item of statusList">{{item.description}}</option>
          </select>
          <i></i>
        </label>
      </div>
      <div class="form-group" [hidden]="prospectEditModel.Status != 5007">
        <label class="form-label">
          Feedback
        </label>
        <div class="select-dropdown multiselectdesign margin-right-15  multi-check-dropdown">
          <!--<angular2-multiselect formControlName="editlstFeedback" [data]="feedackList" [(ngModel)]="prospectModel.Feedback" [settings]="defaultSettings"></angular2-multiselect>-->
          <mat-form-field>
            <mat-select placeholder="Select" (click)="addClassToOverlayContainer()" [(ngModel)]="prospectEditModel.Feedback" name="editlstFeedback" [ngModelOptions]="{standalone: true}" multiple>
              @for (feedack of feedackList; track feedack) {
              <mat-option [value]="feedack.id" class="multi-dropdown-item">{{feedack.name}}</mat-option>
              }
              <mat-option class="matoptionnodata" *ngIf="feedackList?.length === 0" disabled>
                Nothing found...
              </mat-option>
            </mat-select>
          </mat-form-field>
          <i></i>
        </div>
      </div>
      <div class="form-group">
        <label class="form-label">
          Notes
        </label>
        <input placeholder="Notes" formControlName="edittxtNotes" type="text" maxlength="500" [(ngModel)]="prospectEditModel.Notes" class="form-control ">
      </div>
      <div class="form-group margin-top-20">
        <div class="text-right">
          <button type="button" (click)="onClose()" class="btn btn-default btn-lg">Cancel</button>
          <button type="button" (click)="saveDetails()" class="btn btn-success btn-lg">Save</button>
        </div>

      </div>

    </form>
  </div>
</ng-template>
